import { Dialog, DialogContent } from "@spz/ui/components/dialog";
import { useTranslation } from "react-i18next";
import { WorkflowDialogContent } from "./workflow-dialog-content";
import { WorkflowDialogFooter } from "./workflow-dialog-footer";
import { WorkflowDialogHeader } from "./workflow-dialog-header";
import { useWorkflowFormContext } from "./workflow-form-context";

export interface WorkflowTransitionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onFormSubmit: (e: React.FormEvent) => Promise<void>;
}

export function WorkflowTransitionDialog(props: WorkflowTransitionDialogProps) {
  const { t } = useTranslation();

  const formContext = useWorkflowFormContext();
  const schema = formContext?.schema;

  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent title={t(schema?.action?.title_key ?? "")}>
        {schema ? (
          <form onSubmit={props.onFormSubmit} autoComplete="off">
            <WorkflowDialogHeader className="px-6 pt-6" />
            <WorkflowDialogContent className="px-6" />
            <WorkflowDialogFooter
              onButtonClick={(action) => {
                if (action === "cancel") {
                  props.onOpenChange(false);
                  return;
                }
              }}
            />
          </form>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
